import React, { useEffect, useState } from 'react'
import { Form, Input, Button, Checkbox, Row, Col, Select } from 'antd';
import FileBox from '../../components/file';
import { connect } from 'react-redux';
import {updateProduct, getProductDetails} from '../../actions/product';

const { Option } = Select;
const EditProduct = ({updateProduct, getProductDetails, id, fnc, close}) => {
    const [isExpireable, setIsExpireable] = useState('')
    const [form] = Form.useForm();
    useEffect( async () => {
        const res = await getProductDetails(id)
        
        form.setFieldsValue({
            name : res?.name,
            life_time : res?.life_time,
            price : res?.price,
            color : 'none',
            weight :  res?.weight,
            weight_unit : res?.weight_unit,
            active : res?.active,
            description : res?.description
        })
    }, [])
    const onFinish = async (values) => {
        const res = await updateProduct(values,id)
       
        if(res === 201){
            fnc()
            close()
            form.resetFields()
        }
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    return ( 
        <Form
            name="Edit Product"
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            form={form}
            >
            <Row gutter={16}>
            <Col  xs={24}  md={12}>
                <Form.Item
                    label="Product Name"
                    name="name"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Product price"
                    name="price"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input />
                </Form.Item>
                {/* <Form.Item
                    label="Product color"
                    name="color"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input />
                </Form.Item> */}
                

                <Form.Item
                    label="Weight"
                    name="weight"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Input type="number" />
                </Form.Item>
                    
                <Form.Item
                    label="Weight unit"
                    name="weight_unit"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} >
                    <Option value="Kg">kg</Option>
                    <Option value="g">gm</Option>
                    <Option value="ml">ml</Option>
                    <Option value="L">L</Option>
                    <Option value="lb">lb</Option>
                    <Option value="oz">oz</Option>
                    <Option value="kl">kl</Option>
                    <Option value="gsm">gsm</Option>
                    </Select>
                </Form.Item>
                
            </Col>
            <Col  xs={24}  md={12}>
                <Form.Item
                    label="Product duribility"
                    name="life_time"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} onChange={(e)=> setIsExpireable(e)}>
                    <Option value="expireable">Expireable</Option>
                    <Option value="nonexpireable">Non-expireable</Option>
                    </Select>
                </Form.Item>
                {/* {isExpireable === 'expireable' ? 
                    <Form.Item
                        label="Expiry Date"
                        name="expiry_date"
                        rules={[
                        {
                            required: true,
                            message: 'This field is required',
                        },
                        ]}
                    >
                        <Input type="date"/>
                    </Form.Item>
                : null} */}
                <Form.Item
                    label="Status"
                    name="active"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]}
                >
                    <Select  style={{ width: '100%' }} >
                    <Option value="active">Active</Option>
                    <Option value="inactive">Inactive</Option>
                    </Select>
                </Form.Item>

                {/* <FileBox
                    label="Product Image (600X600)"
                    name="image"
                    rules={[
                    {
                        required: true,
                        message: 'This field is required',
                    },
                    ]} 
                />

            
                <FileBox
                    label="Product Thumbnail (300X300)"
                    name="thumbnail"
                    
                /> */}


                <Form.Item
                    label="Description"
                    name="description"
                >
                    <Input.TextArea showCount maxLength={100} />
                </Form.Item>
            </Col>
            <Col xs={24}>
                <br />
                <Form.Item
                    // wrapperCol={{
                    // offset: 1,
                    // span: 22,
                    // }}
                    style={{textAlign: 'center'}}
                >
                    <Button type="primary" htmlType="submit">
                    Submit
                    </Button>
                </Form.Item>
            </Col>
           

            </Row>
        </Form>
     );
}
 
export default connect(null,{updateProduct,getProductDetails})(EditProduct);